import React, { useState } from 'react';
import {
    createStyles,
    ActionIcon,
    Slider,
    RangeSlider,
    Stack,
    Select,
    MultiSelect,
    Title,
    Switch,
    Checkbox, Button
} from '@mantine/core';
import {
    IconBell,
    IconHome,
    IconMapPin,
    IconUser,
} from '@tabler/icons';
import { SearchBarCard } from './SearchBarCard'


const useStyles = createStyles((theme) => ({
    mainArea: {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed',
        backgroundColor: 'white',
        //marginTop: 120,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
        bottom: 0,
        left: 0,
        height: '68px',
        width: '100%',
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));
//pw useradd -n g2ops_mgmt -c "Test Management account" -s /bin/sh -m -w random -G www
const mockMakes = [
    { value: 'Audi', label: 'Audi' },
    { value: 'Buick', label: 'Buick' },
    { value: 'Bentley', label: 'Bentley' },
    { value: 'Chevrolet', label: 'Chevrolet' },
    { value: 'Datsun', label: 'Datsun' },
    { value: 'Fiskar', label: 'Fiskar' },
    { value: 'Ford', label: 'Ford' },
    { value: 'Pagani', label: 'Pagani' },
    { value: 'Porsche', label: 'Porsche' },
];
const mockModels = [
    { value: 'R8', label: 'R8' },
    { value: 'Enclave', label: 'Enclave' },
    { value: 'Continental GT', label: 'Continental GT' },
    { value: 'Corvette', label: 'Corvette' },
    { value: '270z', label: '270z' },
    { value: 'Fiskar', label: 'Fiskar' },
    { value: 'Mustang', label: 'Mustang' },
    { value: 'Hauyra', label: 'Hauyra' },
    { value: '911 GT3', label: '911 GT3' },
];
const mockTransmissions = [
    { value: 'Automatic', label: 'Automatic' },
    { value: 'Manual', label: 'Manual' },
];

export function FilterCard() {
    const { classes } = useStyles();
    const [checked, setChecked] = useState(true);
    
    
    function valueLabelFormat(value: number) {
        let scaledValue = value;

        return `${scaledValue}`;
    }
    //temporary to ensure we understand clicks then... set up the dispatch events
    function handleMenuClick(e) {
        console.log("menu area clicked");
        console.log(e.target.id);
        console.log(window.screen.width);
        console.log(window.screen.height);
        console.log("after width X height");
    }
    return (
        <>
            <SearchBarCard />
            <br/>
            <Select 
                label="Car Make"
                data={mockMakes}
                searchable
                clearable
            />
            <MultiSelect 
                label="Car Models"
                data={mockModels}
                searchable
                clearable
            />
            <Select 
                label="Transmission"
                data={mockTransmissions}
                clearable
            />
            <br/>
            <Title order={5}>Year Range</Title>
            <RangeSlider
                step={1}
                min={1960}
                max={2023}
                disabled={true}
                label={valueLabelFormat}
                labelAlwaysOn
                defaultValue={[1990, 2003]}
            />
            <Switch
                checked={checked}
                onChange={(event) => setChecked(event.currentTarget.setChecked)}
                labelPosition="left"
                label={"Any Years"}
            />
            <br/>
            <Title order={5}>Distance (Miles)</Title>
            <RangeSlider
                step={1}
                min={0}
                max={100}
                disabled={true}
                label={valueLabelFormat}
                labelAlwaysOn
                defaultValue={[40, 80]}
            />
            <Switch
                checked={checked}
                onChange={(event) => setChecked(event.currentTarget.setChecked)}
                labelPosition="right"
                label={"Any Distance"}
            />
            <br/>
            <br/>
            <div className={classes.buttonContainer} >
                <div className={classes.buttonArea} >
                    <Button className={classes.buttonItem}>Reset</Button>
                </div>
                <div className={classes.buttonArea} >
                    <Button className={classes.buttonItem}>Apply</Button>
                </div>
            </div>
        </>
  );
}
